/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CartAddress { 
    address?: string | null;
    longitude?: number | null;
    latitude?: number | null;
    entrance?: string | null;
    floor?: string | null;
    flat?: string | null;
    addressNote?: string | null;
}

